app.controller("hall",['$scope',function($scope){
      $scope.currentNavItem=1;

}])
 